import debounce from 'lodash.debounce'

import date from './date'

/*!
 * Get the contrasting color for any hex color
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * Derived from work by Brian Suda, https://24ways.org/2010/calculating-color-contrast/
 * @param  {String} A hexcolor value
 * @return {String} The contrasting color (black or white)
 */
const getContrast = function (hexcolor) {
  const dark = '#000'
  const light = '#FFF'
  if (hexcolor === null || hexcolor === '#null') {
    return dark
  }
  // If a leading # is provided, remove it
  if (hexcolor.slice(0, 1) === '#') {
    hexcolor = hexcolor.slice(1)
  }

  // If a three-character hexcode, make six-character
  if (hexcolor.length === 3) {
    hexcolor = hexcolor
      .split('')
      .map(function (hex) {
        return hex + hex
      })
      .join('')
  }

  // Convert to RGB value
  const r = parseInt(hexcolor.substr(0, 2), 16)
  const g = parseInt(hexcolor.substr(2, 2), 16)
  const b = parseInt(hexcolor.substr(4, 2), 16)

  // Get YIQ ratio
  const yiq = (r * 299 + g * 587 + b * 114) / 1000

  // Check contrast
  return yiq >= 128 ? dark : light
}

const openInternalReminderLink = function (internalTypeId, link, refid) {
  // Convert v5 internal reminder links to tempoary v6 compatibility
  // TODO Add ability to add reference id in database
  switch (link) {
    case 'EditVehicle':
      return window.$nuxt.$router.push({
        name: 'vehicles-vehicleid-edit',
        params: { vehicleid: refid },
        query: { irid: internalTypeId },
      })
    case 'EditMachine':
      return window.$nuxt.$router.push({
        name: 'machines-machineid-edit',
        params: { machineid: refid },
        query: { irid: internalTypeId },
      })
    case 'EmployeeView':
      return window.$nuxt.$router.push({
        name: 'employees-id-view-compliance',
        params: { id: refid },
        query: { irid: internalTypeId },
      })
    case 'EditEmployeeDetails':
      return window.$nuxt.$router.push({
        name: 'employees-id-edit',
        params: { id: refid },
        query: { irid: internalTypeId },
      })
    case 'ReminderEmployeeGear':
      return window.$nuxt.$router.push({
        name: 'reminders-goto-employeegear',
        params: { id: refid },
        query: { irid: internalTypeId },
      })
    case 'ReminderCrewGear':
      return window.$nuxt.$router.push({
        name: 'reminders-goto-crewgear',
        params: { id: refid },
        query: { irid: internalTypeId },
      })
  }
}
const toolkitObject = {
  debounce,
  getContrast,
  openInternalReminderLink,
  date,
}

export default toolkitObject
